import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 33;

export const migration_32_33:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {component} = boxSnapshot;

                        if( component.name === 'Chart' )
                        {
                            const {componentDesc} = boxSnapshot;

                            Object.values(componentDesc._properties).forEach((propSnapshot:any) =>
                            {
                                if( propSnapshot.name === 'chart' )
                                {
                                    setGridLinesValue(propSnapshot._value);
                                    setGridLinestBindPaths(propSnapshot._bindGroups, designState.bindings);
                                }
                            });
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function setGridLinesValue(value:any)
{
    const gridLinesValue = {
        'display': {
            '__type': 'BOOLEAN',
            'value': true
        }
    };

    value.axes.xAxis.gridLines = gridLinesValue;
    value.axes.yAxis.gridLines = gridLinesValue;
}

function setGridLinestBindPaths(bindGroups:any, bindings:any)
{
    const axesBindGroup:any = Object.values(bindGroups).find((bindGroup:any) => bindGroup.name === 'axes');

    const axesPath:any = Object.values(axesBindGroup.rootBindItem.paths[0])
        .find((item:any) => item.path === 'axes');

    const xAxisPath:any = Object.values(axesPath.paths[0])
        .find((item:any) => item.path === 'xAxis');

    const yAxisPath:any = Object.values(axesPath.paths[0])
        .find((item:any) => item.path === 'yAxis');

    axesBindGroup.rootBindItem.paths[0][axesPath.id].paths[0][xAxisPath.id].paths[0]['52dbb5d5-b121-4d6c-8211-91f8c05e8ae4'] = {
        'id': '52dbb5d5-b121-4d6c-8211-91f8c05e8ae4',
        'path': 'gridLines',
        'templatePath': 'axes.xAxis.gridLines',
        'paths': [
            {
                '473c7609-3a56-4198-905d-7d878d800127': {
                    'id': '473c7609-3a56-4198-905d-7d878d800127',
                    'path': 'display',
                    'templatePath': 'axes.xAxis.gridLines.display',
                    'paths': null,
                    'bindingId': null
                }
            }
        ],
        'bindingId': null
    };

    axesBindGroup.rootBindItem.paths[0][axesPath.id].paths[0][yAxisPath.id].paths[0]['e66d144c-cd47-48fc-8da8-06ab0393356e'] = {
        'id': 'e66d144c-cd47-48fc-8da8-06ab0393356e',
        'path': 'gridLines',
        'templatePath': 'axes.yAxis.gridLines',
        'paths': [
            {
                '34b843e8-c2e7-4c69-8366-9c767a5a3699': {
                    'id': '34b843e8-c2e7-4c69-8366-9c767a5a3699',
                    'path': 'display',
                    'templatePath': 'axes.yAxis.gridLines.display',
                    'paths': null,
                    'bindingId': null
                }
            }
        ],
        'bindingId': null
    };
}
